import { render, staticRenderFns } from "./NonStandard.vue?vue&type=template&id=117b67aa&"
import script from "./NonStandard.vue?vue&type=script&lang=js&"
export * from "./NonStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports